import * as types from '../mutation-types'
import Vue from 'vue'
import core from '@/js/core/core'
import moment from 'moment'

// initial state
const state = {
    promotionDetails: [], // promotion details
    promotionFlag: false, // got promotion or not
    // promotionJoinedFlag: false, // joined or not
    promotionShowJoinSuccess: false, // true if join and bet success and show joined successful msg
    promotionBetStatus: false, // true if user ady joined and bet success during period 
    promotionBetIndex: [], // store betform index which is joined for promotion
    promotionBetWithoutJoin: false, // true if the bets not joining promotion
    // promptPromotionConfirm: false, // true to show prompt comfirm if not meet min bet req
}

// getters
const getters = {
    promotionDetails: state => state.promotionDetails,
    promotionFlag: state => state.promotionFlag,
    // promotionJoinedFlag: state => state.promotionJoinedFlag,
    promotionShowJoinSuccess: state => state.promotionShowJoinSuccess,
    promotionBetStatus: state => state.promotionBetStatus,
    promotionBetIndex: state => state.promotionBetIndex,
    promotionBetWithoutJoin: state => state.promotionBetWithoutJoin,
    // promptPromotionConfirm: state => state.promptPromotionConfirm,
}

// actions
const actions = {
  setPromoDetails(context, payload) {
    if(payload.promo_details != false && Object.keys(payload.promo_details).length > 0){
      this.commit('PROMO_DETAILS', payload.promo_details);
      this.commit('PROMO_FLAG', true);
      this.commit('PROMO_BET_STATUS', payload.promotionBetStatus);
      // if(payload.promotionBetStatus){
        // this.commit('PROMO_JOINED_FLAG', true);
      // }
    }
  },
  // getWagerPromotionStatus(context, payload){
  //   core.$ajax({
  //     method: 'get',
  //     url: 'sport-wager/getWagerPromotionStatus',
  //   }).done(((res)=> {
  //       this.commit('PROMO_DETAILS', res.promotionData==false?[]:res.promotionData);
  //       this.commit('PROMO_FLAG', res.promotionData==false?false:true);
  //       if(res.promotionBetStatus!=undefined){
  //         // if(this.getters.promotionBetStatus && !res.promotionBetStatus){
  //         //   this.commit('PROMO_JOINED_FLAG', false);
  //         // } else if(res.promotionBetStatus) {
  //         //   this.commit('PROMO_JOINED_FLAG', true);
  //         // }
  //         this.commit('PROMO_BET_STATUS', res.promotionBetStatus);
  //       }
  //   }).bind(this)).catch((errRes)=> {
  //     console.error(errRes)
  //   })
  // },
  isSportValidPromo(context, payload){ // check if the bet's sport & bettype & market are valid for promotion
    var eventObj = payload.eventObj
    var bt = payload.bt
    var res = false
    if(eventObj && bt && this.getters.promotionDetails){
      const eventDt = eventObj.dt? eventObj.dt.split(' ')[0]: eventObj.evedt? eventObj.evedt.split(' ')[0]:''
      var promo_sp_id = this.getters.promotionDetails.sp_sport.split(",")
      var promo_bt_not_allow = this.getters.promotionDetails.sp_bt_not_allow.split(",")
      var promo_sp_wager_type = this.getters.promotionDetails.sp_wager_type.split(",")
      var sp_wager_type = false
      
      // get today date with timezone -4
      var timeZoneSet = '-04:00'
      // var timeZone = window._timeZone
      var tdyDate = moment().utcOffset(timeZoneSet).format("YYYY-MM-DD").toString();
      // if(timeZone.list!=undefined && timeZone.list[timeZone.default]!=undefined){
      //     timeZoneSet=timeZone.list[timeZone.default][0]
      //     tdyDate = moment().utcOffset(timeZoneSet).format("YYYY/MM/DD HH:mm:ss").toString();
      // } else if(timeZone!=undefined && timeZone.timeS!=undefined) {
      //   tdyDate = moment().utcOffset(timeZoneSet).format("YYYY/MM/DD HH:mm:ss").toString();
      // }
  
      if(eventObj.rbstatus){
        if(promo_sp_wager_type.includes("3")){ // inplay
          sp_wager_type = true
        }
      } else {
        if(eventDt != ''){
          if(eventDt == tdyDate) {
            if(promo_sp_wager_type.includes("1")){ // today
              sp_wager_type = true
            }
          } else {
            if(promo_sp_wager_type.includes("2")){ //early
              sp_wager_type = true
            }
          }
        }
      }
  
      res = (promo_sp_id.includes(String(eventObj.sptid)) && !promo_bt_not_allow.includes(bt) && sp_wager_type)
    }
    if(payload){
      if(payload.callback){
        return payload.callback(res)
      }
    }
  }
}

// mutations
const mutations = {
  // [types.PROMO_JOINED_FLAG] (state, payload ) {
  //   state.promotionJoinedFlag = payload
  // },
  [types.PROMO_FLAG] (state, payload ) {
    state.promotionFlag = payload
  },
  [types.PROMO_DETAILS] (state, payload ) {
    state.promotionDetails = payload
  },
  [types.PROMO_SHOW_JOIN_SUCCESS] (state, payload ) {
    state.promotionShowJoinSuccess = payload
  },
  [types.PROMO_BET_STATUS] (state, payload ) {
    state.promotionBetStatus = payload
  },
  [types.PROMO_BET_INDEX] (state, payload ) {
    state.promotionBetIndex = payload
  },
  [types.PROMO_BET_WITHOUT_JOIN] (state, payload ) {
    state.promotionBetWithoutJoin = payload
  },
  // [types.PROMO_PROMPT_CONFIRM] (state, payload ) {
  //   state.promptPromotionConfirm = payload
  // },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/wob/vue/store/modules/promotion.js